import React, { createContext, useContext, FC, ReactNode } from 'react'

import { EPGCacheManager } from '@/shared/cache/epgCacheMahager'
import { ExtendedEpgElement } from '@/types/epg/Epg'
import { useCacheRepository } from '@/features/repositories/useCacheRepositotory'
import Channel from '@/shared/classes/channels/channel'

type ContainerProviderProps = {
    children: ReactNode
}

interface ICacheManager {
    getEpgFromCache: () => Promise<ExtendedEpgElement[] | null>
    getTvFromCache: () => Promise<Channel[] | null>
    setEpgToCache: (data: ExtendedEpgElement[]) => void
    setTvToCache: (data: Channel[]) => void
    clearCache: () => void
}

const CacheContext = createContext<ICacheManager | null>(null)

const useEPGContext = () => useContext(CacheContext)

const CacheProvider: FC<ContainerProviderProps> = ({ children }) => {
    const cacheManager = useCacheRepository(EPGCacheManager)
    if (!cacheManager) return <></>
    return (
        <CacheContext.Provider value={cacheManager}>
            {children}
        </CacheContext.Provider>
    )
}

export { useEPGContext, CacheProvider }
